export const CLOUD_SHAPES = [
  {
    body: 'M-30 1C-32-2-28-6-24-6C-24-10-19-13-14-11C-12-18-1-19 4-12C10-15 17-11 17-6C23-8 29-3 27 1C34 2 32 5 25 6C14 8-16 8-26 6C-32 5-35 3-30 1Z',
    shade:
      'M-30 2C-23 4-17 1-12 2C-5 5 4 1 10 2C18 5 25 1 30 3C30 5 27 6 23 6C10 8-16 7-26 5C-29 5-31 4-30 2Z',
    folds: 'M-24-5C-20-8-15-7-13-3M-10-11C-4-14 2-10 3-5M8-5C12-7 17-4 18-1',
    rim: 'M-25-7C-23-11-19-12-16-11M-12-12C-10-17-2-18 2-13M6-12C10-13 14-10 15-7',
  },
  {
    body: 'M-34 2C-35-2-29-5-23-4C-22-10-14-12-9-7C-5-12 4-12 8-6C14-9 23-6 23-1C29-3 35 0 33 3C38 6 22 8 14 7C2 9-6 7-15 8C-23 7-35 7-34 2Z',
    shade:
      'M-33 3C-26 3-21 1-16 3C-9 6-3 2 3 3C13 6 22 2 31 3C36 5 26 7 16 6C4 8-5 6-15 7C-26 6-33 6-33 3Z',
    folds: 'M-22-3C-18-6-12-5-10-2M-6-6C-2-8 4-7 6-3M12-3C16-4 20-2 21 1',
    rim: 'M-22-5C-21-9-15-10-11-7M-7-7C-3-10 3-10 6-7M10-6C15-7 20-5 21-2',
  },
  {
    body: 'M-29 1C-30-4-24-7-19-5C-20-10-14-14-9-11C-5-16 5-14 7-8C14-13 24-7 23-1C29-2 34 2 30 5C23 8 14 6 7 7C-4 8-16 6-24 6C-32 6-35 3-29 1Z',
    shade:
      'M-29 2C-22 4-18 1-13 2C-6 5 1 1 7 2C14 4 23 2 30 3C29 6 21 6 14 5C5 8-8 5-17 5C-24 5-29 5-29 2Z',
    folds: 'M-18-4C-15-7-10-6-8-2M-7-9C-3-12 3-9 4-4M9-5C14-8 20-4 21 0',
    rim: 'M-18-7C-17-11-13-12-10-10M-7-11C-3-14 3-12 5-8M9-8C14-11 21-7 21-3',
  },
] as const;
